
import React from 'react';

const StatsSection: React.FC = () => {
  const stats = [
    {
      number: '50,000+',
      label: 'Patients Treated',
      icon: 'ri-user-heart-line',
      color: 'text-teal-600',
      bgColor: 'bg-teal-100'
    },
    {
      number: '98%',
      label: 'Patient Satisfaction',
      icon: 'ri-heart-line',
      color: 'text-red-600',
      bgColor: 'bg-red-100'
    },
    {
      number: '150+',
      label: 'Medical Professionals',
      icon: 'ri-team-line',
      color: 'text-blue-600',
      bgColor: 'bg-blue-100'
    },
    {
      number: '24/7',
      label: 'Emergency Care',
      icon: 'ri-time-line',
      color: 'text-green-600',
      bgColor: 'bg-green-100'
    },
    {
      number: '15',
      label: 'Specialized Departments',
      icon: 'ri-hospital-line',
      color: 'text-purple-600',
      bgColor: 'bg-purple-100'
    },
    {
      number: '20+',
      label: 'Years of Excellence',
      icon: 'ri-award-line',
      color: 'text-orange-600',
      bgColor: 'bg-orange-100'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Impact in Numbers</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            These numbers reflect our commitment to providing exceptional healthcare 
            and the trust our community places in us.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center group hover:transform hover:scale-105 transition-all duration-300">
              <div className={`w-16 h-16 ${stat.bgColor} rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:shadow-lg transition-shadow`}>
                <i className={`${stat.icon} text-2xl ${stat.color}`}></i>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">{stat.number}</div>
              <div className="text-sm text-gray-600 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-teal-50 to-blue-50 rounded-3xl p-8 md:p-12">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                Recognized Excellence in Healthcare
              </h3>
              <p className="text-gray-600 mb-6">
                Our commitment to quality care has earned us recognition from leading healthcare 
                organizations and accreditation bodies. We continuously strive to exceed industry 
                standards and provide the best possible outcomes for our patients.
              </p>
              <div className="flex flex-wrap gap-4">
                <div className="flex items-center space-x-2 bg-white px-4 py-2 rounded-lg shadow-sm">
                  <i className="ri-star-fill text-yellow-500"></i>
                  <span className="text-sm font-medium text-gray-700">5-Star Rating</span>
                </div>
                <div className="flex items-center space-x-2 bg-white px-4 py-2 rounded-lg shadow-sm">
                  <i className="ri-shield-check-line text-green-500"></i>
                  <span className="text-sm font-medium text-gray-700">JCI Accredited</span>
                </div>
                <div className="flex items-center space-x-2 bg-white px-4 py-2 rounded-lg shadow-sm">
                  <i className="ri-award-line text-blue-500"></i>
                  <span className="text-sm font-medium text-gray-700">Top Hospital Award</span>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/dad590cbf721dc09630223d5ee3d18c0.jpg"
                alt="Healthcare awards and certifications"
                className="rounded-2xl shadow-lg object-cover w-full h-64 object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
